/**
 * Klove Atelier — High-Performance Interaction & Animation Engine
 * 60fps, Zero Layout Thrashing, Hardware Accelerated Transitions.
 */

(function() {
  'use strict';

  // Obsługa preferencji ograniczonego ruchu
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initSectionObserver() {
    if (prefersReducedMotion) return;

    const sections = document.querySelectorAll(
      '.bed-hero, .bed-usp, .bed-models, .bed-visualizer, .bed-craftsmanship, .bed-layers, .bed-safety-certifications, .bed-fabric-lab, .bed-samples, .bed-reviews, .bed-trust-strip'
    );

    if (!('IntersectionObserver' in window)) return;

    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('klove-in-view');
          obs.unobserve(entry.target);
        }
      });
    }, {
      root: null,
      rootMargin: '0px 0px -60px 0px',
      threshold: 0.08
    });

    sections.forEach(sec => {
      sec.classList.add('klove-reveal-section');
      observer.observe(sec);
    });
  }

  // Obsługa płynnego Mega Menu na hover (dla urządzeń desktopowych z myszką)
  function initMegaMenuHover() {
    const isDesktop = window.matchMedia('(min-width: 990px)').matches;
    if (!isDesktop) return;

    const megaDetails = document.querySelectorAll('.klove-mega-details');
    megaDetails.forEach(details => {
      let timeout;

      details.addEventListener('mouseenter', () => {
        clearTimeout(timeout);
        details.setAttribute('open', '');
      });

      details.addEventListener('mouseleave', () => {
        timeout = setTimeout(() => {
          details.removeAttribute('open');
        }, 180);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initSectionObserver();
      initMegaMenuHover();
    });
  } else {
    initSectionObserver();
    initMegaMenuHover();
  }
})();
